export const contextualDatasets = [
  {
    id: 'POP',
  },
];

export const monthlyContextualDatasets = [
  {
    id: 'BUD',
  },
];
